import HttpRequest from './HttpRequest'

class AuthProvider extends HttpRequest {
  login (payload) {
    return this.post('/v1/public/super-admin/login', payload)
  }
}

export default AuthProvider
